import { Box, styled } from '@mui/material'
import { useOrgChart } from 'hooks'
import { FC } from 'react'
import ReactFlow, { Controls } from 'react-flow-renderer'
import { MyIdentityLayout, SubHeader } from 'components'
import { PersonNode } from './PersonNode'
import { OrgChartSkeleton } from './OrgChartSkeleton'

const StyledBox = styled(Box)({
    marginTop: '65px',
    width: '100%',
    height: '90vh',
})

export const nodeTypes = {
    person: PersonNode,
}

export const OrgChart: FC<{ personGuid: string }> = (props) => {
    const { data, isLoading } = useOrgChart(props.personGuid)

    return (
        <MyIdentityLayout subHeader={<SubHeader showBackButtonOnly />}>
            {isLoading && (
                <StyledBox>
                    <OrgChartSkeleton />
                </StyledBox>
            )}

            {data && (
                <StyledBox
                    data-ai-explain-section="listing"
                    role="region"
                    aria-label="Organization chart"
                >
                    <ReactFlow
                        nodesDraggable={false}
                        nodesConnectable={false}
                        // @ts-ignore*
                        nodeTypes={nodeTypes}
                        elements={data}
                    >
                        <Controls
                            style={{
                                bottom: 'unset',
                                left: 'unset',
                                top: '32px',
                                right: '32px',
                            }}
                            className="eid-org-chart-controls"
                        />
                    </ReactFlow>
                </StyledBox>
            )}
        </MyIdentityLayout>
    )
}
